<template>
  <ValidationObserver ref='validationObserver'>
    <div class="new-form-row">
      <p class="new-form-text">Endereço:</p>
    </div>
    <div class="new-form-row">
      <ValidationProvider vid="state" rules='required' v-slot="{ errors }">
        <div class="new-form-input">
          <input type="text"  name="state" placeholder="Estado *" data-cy="state" v-model="form.state">
        </div>
        <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
    <div class="new-form-row">
      <ValidationProvider vid="city" rules='required' v-slot="{ errors }">
        <div class="new-form-input">
          <input type="text"  name="city" placeholder="Cidade *" data-cy="city" v-model="form.city">
        </div>
        <span class="new-form-error" v-if="errors[0]">{{ errors[0] }}</span>
      </ValidationProvider>
    </div>
    <div class="new-form-row">
      <p class="new-form-text">Dados de pagamento:</p>
      <p>O seu primeiro boleto será emitido por aqui e os posteriores serão enviados por email</p>
    </div>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'BoletoPaymentForm',
  props: {
    formData: {
      city: String,
      state: String
    }
  },
  data: function () {
    return {
      form: this.formData
    };
  },
  methods: {
    validForm: async function () {
      return this.$refs.validationObserver.validate();
    },
    getValidationObserver () {
      return this.$refs.validationObserver;
    }
  }
};
</script>
